/* eslint no-use-before-define: 0 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { t } from 'i18next';
import { titleize } from 'underscore.string';
import { intersectionWith } from 'lodash';
import { DISABLE_BLANK_FILTER_WHITELIST, STANDARD_REFERENCE_NUMBERS, } from '../constants';
import { Button, Label, Textarea } from '@cargomatic/ui';
import RadioList from 'components/v2/RadioList';
const FILTER_LIST = {
    BLANK: 'blank',
    NOT_BLANK: 'notBlank',
    STARTS_WITH: 'startsWith',
};
const getDefaultState = () => {
    const filterOptions = Object.keys(FILTER_LIST).map((key) => ({
        id: key,
        name: t(key),
        value: FILTER_LIST[key],
        description: t(`${key}_DESCRIPTION`),
    }));
    return {
        startsWithText: '',
        startsWithValues: [],
        filterOptions,
        selectedFilter: filterOptions.find((filter) => filter.value === FILTER_LIST.STARTS_WITH),
    };
};
const slugsMap = {
    equipment_id: { localizationSlug: 'EQUIPMENTS' },
    chassis_number: { localizationSlug: 'EQUIPMENTS' },
    trailer_number: { localizationSlug: 'EQUIPMENTS' },
    shipment_id: { localizationSlug: 'SHIPMENT', count: 2 },
    order_id: { localizationSlug: 'ORDER', count: 2 },
    reference_numbers: { localizationSlug: 'REFERENCE_NUMBERS' },
    delivery_order: { localizationSlug: 'DELIVERY_ORDER' },
    gate_dropoff: { localizationSlug: 'GATE_DROPOFF' },
    gate_pickup: { localizationSlug: 'GATE_PICKUP' },
    house_bill_number: { localizationSlug: 'HOUSE_BILL_NUMBER' },
    isa: { localizationSlug: 'ISA' },
    master_bol: { localizationSlug: 'MASTER_BOL' },
    mg_load_id: { localizationSlug: 'MG_LOAD_ID' },
    mo_number: { localizationSlug: 'MO_NUMBER' },
    pu_number: { localizationSlug: 'PU_NUMBER' },
    seal_number: { localizationSlug: 'SEAL_NUMBER' },
    tracking_id: { localizationSlug: 'TRACKING_ID' },
    truck_order: { localizationSlug: 'TRUCK_ORDER' },
    VRID: { localizationSlug: 'VRID' },
    work_order_number: { localizationSlug: 'WORK_ORDER_NUMBER' },
    booking_number: { localizationSlug: 'BOOKING_NUMBER' },
};
class TextFilterStartsWith extends Component {
    constructor(props) {
        super(props);
        this.onChange = (event) => {
            const newValue = event.target.value;
            if (this.state.startsWithText !== newValue) {
                this.setState({
                    startsWithText: newValue,
                });
            }
        };
        this.shouldDisableRadioGroup = () => {
            const columnId = this.props.column.colId;
            return DISABLE_BLANK_FILTER_WHITELIST.includes(columnId);
        };
        this.handleClearFilter = () => {
            this.setState(getDefaultState(), () => {
                this.props.filterChangedCallback();
            });
        };
        this.handleBulkFilter = () => {
            if (this.state.selectedFilter.value === FILTER_LIST.STARTS_WITH) {
                const value = this.state.startsWithText;
                let startsWithValues = [];
                if (value) {
                    startsWithValues = value
                        .replace(/\n/g, ',')
                        .split(',')
                        .map((str) => str.toUpperCase().trim())
                        .filter((str) => str.length > 0);
                }
                if (startsWithValues.length > 0) {
                    const startsWithText = startsWithValues
                        .map((str) => str.toUpperCase())
                        .join('\n');
                    this.setState({ startsWithValues, startsWithText }, () => {
                        this.props.filterChangedCallback();
                    });
                }
            }
            else {
                this.setState({
                    startsWithValues: [],
                    startsWithText: '',
                }, () => {
                    this.props.filterChangedCallback();
                });
            }
        };
        this.state = getDefaultState();
    }
    getModel() {
        const { startsWithValues, selectedFilter } = this.state;
        if (selectedFilter.value === FILTER_LIST.BLANK) {
            return { type: 'blank', filterType: 'text' };
        }
        if (selectedFilter.value === FILTER_LIST.NOT_BLANK) {
            return { type: 'notBlank', filterType: 'text' };
        }
        if (!startsWithValues.length)
            return {};
        const model = {};
        startsWithValues.forEach((value, index) => {
            model[`condition${index + 1}`] = {
                type: 'startsWith',
                filter: value,
                filterType: 'text',
            };
        });
        return Object.assign(Object.assign({}, model), { operator: 'OR' });
    }
    setModel(model) {
        if (!model)
            return this.setState(getDefaultState());
        const condition = model.condition1;
        if ((condition === null || condition === void 0 ? void 0 : condition.type) === 'blank' || (condition === null || condition === void 0 ? void 0 : condition.type) === 'notBlank') {
            const selected = this.state.filterOptions.find((opt) => opt.value === condition.type);
            this.setState({ selectedFilter: selected });
            return;
        }
        let startsWithValues = [];
        Object.keys(model).forEach((item) => {
            if (model[item].type === 'startsWith' && model[item].filter) {
                startsWithValues.push(model[item].filter);
            }
        });
        const startsWithText = startsWithValues.join('\n');
        this.setState({
            startsWithValues,
            startsWithText,
        });
    }
    doesFilterPass(params) {
        var _a, _b;
        try {
            const { startsWithValues, selectedFilter } = this.state;
            let columnId = this.props.column.colId;
            if (STANDARD_REFERENCE_NUMBERS.includes(columnId)) {
                columnId = 'reference_numbers';
            }
            const columnValue = params.node.data[columnId];
            // Handle 'blank' & 'notBlank' filter
            if (selectedFilter.value === FILTER_LIST.BLANK ||
                selectedFilter.value === FILTER_LIST.NOT_BLANK) {
                return true;
            }
            // Handle 'startsWith' filter
            const filterValues = startsWithValues.map((item) => { var _a; return (_a = (item || '')) === null || _a === void 0 ? void 0 : _a.toLowerCase(); });
            if (Array.isArray(columnValue)) {
                const values = columnValue.map((item) => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.value) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || (item === null || item === void 0 ? void 0 : item.toLowerCase()) || ''; });
                return (intersectionWith(filterValues, values, (filterMatch, value) => value.startsWith(filterMatch)).length > 0);
            }
            const valueStr = (_b = (_a = (columnValue || '')) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.toLowerCase();
            return filterValues.some((match) => valueStr.startsWith(match));
        }
        catch (e) {
            console.error('Error in doesFilterPass:', e);
        }
    }
    isFilterActive() {
        const { startsWithValues, selectedFilter } = this.state;
        return (selectedFilter.value === FILTER_LIST.BLANK ||
            selectedFilter.value === FILTER_LIST.NOT_BLANK ||
            (startsWithValues || []).length > 0);
    }
    afterGuiAttached() {
        this.focus();
    }
    focus() {
        window.setTimeout(() => {
            const container = ReactDOM.findDOMNode(this.refs.input);
            if (container) {
                container.focus();
            }
        });
    }
    getColumnTitle(column) {
        if (column in slugsMap) {
            return slugsMap[column];
        }
        else {
            return { localizationSlug: 'STATUSES' };
        }
    }
    handleFilterSelect(filter) {
        this.setState({
            selectedFilter: filter,
            startsWithText: '',
            startsWithValues: [],
        });
    }
    render() {
        const { filterOptions, selectedFilter } = this.state;
        const columnTitle = this.getColumnTitle(this.props.column.colId);
        return (React.createElement("div", { className: "px-4 py-5 sm:p-6" },
            React.createElement(RadioList, { disabled: this.shouldDisableRadioGroup(), options: filterOptions, selected: selectedFilter, onSelect: (filter) => this.handleFilterSelect(filter) }),
            React.createElement("div", { className: "mt-2" },
                React.createElement(Label, { className: "mb-2 form-Label" }, t('ADD_COMMA_OR_NEW_LINE_STARTS_WITH', {
                    column: columnTitle.count
                        ? t(columnTitle.localizationSlug, {
                            count: columnTitle.count,
                        })
                        : t(columnTitle.localizationSlug),
                })),
                React.createElement(Textarea, { disabled: selectedFilter.value !== FILTER_LIST.STARTS_WITH, rows: 5, ref: "input", value: this.state.startsWithText, onChange: this.onChange, className: "form-field" })),
            React.createElement("div", { className: "flex justify-between mt-4" },
                React.createElement(Button, { variant: "outline", onClick: () => this.handleClearFilter(this.props.column.colId) }, titleize(t('CLEAR'))),
                React.createElement(Button, { onClick: this.handleBulkFilter }, titleize(t('ADD'))))));
    }
}
export default TextFilterStartsWith;
